// extracted by mini-css-extract-plugin
export default {"container":"Recommendation_container__w0968"};